module.exports = __webpack_public_path__ + "images/locator/icon-map-view-inv-d6e3b210.svg";